import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/services';

export type UseMarkServiceRequestProcessedPayload = {
  serviceRequestId: string;
  is_processed: boolean;
};

export const useMarkServiceRequestProcessed = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['serviceRequestProcessed'],
    mutationFn: ({
      serviceRequestId,
      is_processed,
    }: UseMarkServiceRequestProcessedPayload) =>
      api
        .put(`/v3/service_request/${serviceRequestId}/processed`, {
          is_processed,
        })
        .then((res) => res.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['serviceRequestList'] });
    },
  });
};
